var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10514",
    "data-name": "Grupo 10514",
    transform: "translate(-0.48 -0.41)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_109",
    "data-name": "Elipse 109",
    cx: 50.5,
    cy: 50.5,
    r: 50.5,
    transform: "translate(0.48 0.41)",
    fill: "#58c60f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "done_black_24dp",
    transform: "translate(20.316 20.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3052",
    "data-name": "Trazado 3052",
    d: "M0,0H60.949V60.949H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3053",
    "data-name": "Trazado 3053",
    d: "M19.69,41.037,7.473,27,3.4,31.676,19.69,50.4,54.6,10.28,50.525,5.6Z",
    transform: "translate(1.781 2.933)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0c6482cd.svg";
export { ForwardRef as ReactComponent };